import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaHome, FaChartLine, FaCalendarCheck, FaUser } from "react-icons/fa"; // Import icons
import "../css/StickyFooter.css"; // Import CSS file
import { UserContext } from "../context/UserContext"; // Import UserContext

const StickyFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userRole } = useContext(UserContext); // Get user role from context

  const handleHomeClick = () => {
    if (userRole === "admin") {
      navigate("/dashboard");
    } else if (userRole === "karyawan") {
      navigate("/dashboardkaryawan");
    } else {
      navigate("/");
    }
  };

  const isHomeActive =
    location.pathname === "/dashboard" ||
    location.pathname === "/dashboardkaryawan";

  return (
    <footer className="sticky-footer">
      <div
        className={`footer-icon ${isHomeActive ? "active" : ""}`}
        onClick={handleHomeClick}
      >
        <FaHome className="icon" />
        <span>Home</span>
      </div>
      <div
        className={`footer-icon ${
          location.pathname === "/laporan" ? "active" : ""
        }`}
        onClick={() => navigate("/laporan")}
      >
        <FaChartLine className="icon" />
        <span>Laporan</span>
      </div>
      <div
        className={`footer-icon ${
          location.pathname === "/absensi" ? "active" : ""
        }`}
        onClick={() => navigate("/absensi")}
      >
        <FaCalendarCheck className="icon" />
        <span>Absensi</span>
      </div>
      <div
        className={`footer-icon ${
          location.pathname === "/profile" ? "active" : ""
        }`}
        onClick={() => navigate("/profile")}
      >
        <FaUser className="icon" />
        <span>Profile</span>
      </div>
    </footer>
  );
};

export default StickyFooter;
